import { render, staticRenderFns } from "./AddTrainNewborn.vue?vue&type=template&id=dd49b96a&scoped=true&"
import script from "./AddTrainNewborn.vue?vue&type=script&lang=js&"
export * from "./AddTrainNewborn.vue?vue&type=script&lang=js&"
import style0 from "./AddTrainNewborn.vue?vue&type=style&index=0&id=dd49b96a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd49b96a",
  null
  
)

export default component.exports